<template>
    <div class="ele-body">
        <el-row>
            <el-col>
                <el-card shadow="never" body-style="padding-top: 5px;">
                    <el-tabs v-model="active" class="user-info-tabs">
                        <el-tab-pane label="基本信息" name="info">
                            <el-form ref="infoForm" :model="editForm" :rules="editRules" label-width="90px"
                                style="max-width: 450px;padding-top: 40px;" @keyup.enter.native="save"
                                @submit.native.prevent>
                                <el-form-item label="存储位置:" prop="status">
                                    <el-select v-model="editForm.status" filterable placeholder="请选择存储位置">
                                        <el-option label="本地" value="0"></el-option>
                                        <el-option label="七牛云" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="save">保存更改</el-button>
                                </el-form-item>
                            </el-form>
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";
    export default {
        name: "SysStorageConf",
        components: {},
        data() {
            return {
                active: 'info',  // tab页选中
                table: {
                    url: '/storage/StorageConf/index',
                    where: {}
                }, // 表格配置
                editForm: {}, // 表单数据
                editRules: { // 表单验证规则
                    status: [{
                        required: true,
                        message: '请选择存储位置',
                        trigger: 'blur'
                    }],
                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {
            this.edit();
        },
        methods: {
            /**
             * 显示编辑
             */
            edit() {
                this.$http.get('/storage/StorageConf/info?id=1').then(res => {
                    if (res.data.code === 0) {
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                const loading = this.$loading({
                    lock: true
                });
                this.$http.post('/storage/StorageConf/edit', this.editForm).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                        // this.$refs.table.reload();
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
